// Schnellwahl im Toleranzfeld (C6): eine Toleranzklasse statt Zahlen.
//
//   H7, G6, JS9  → ISO 286 Bohrung (Großbuchstabe, wie auf Zeichnungen)
//   h7, g6, js9  → ISO 286 Welle   (Kleinbuchstabe)
//   f, m, c, v   → ISO 2768-1 (auch groß, auch „2768m“, „ISO 2768-m“)
//
// Liefert { norm } für eine bekannte Klasse, { unbekannt } für etwas, das
// wie eine Klasse aussieht, es aber nicht gibt, und null für alles andere
// (Zahlen wie „0,1“ übernimmt dann smartParseTol).

import { klassen } from '../../../data/iso286';

const { bohrungen, wellen } = klassen();
const BOHRUNGEN = new Set(bohrungen);
const WELLEN = new Set(wellen);

const ISO286_RE = /^([A-Za-z]{1,2})\s*(\d{1,2})$/;
const ISO2768_RE = /^(?:din\s*)?(?:iso\s*)?(?:2768(?:\s*-\s*1)?\s*-?\s*)?([a-z])([hkl])?$/i;
const ISO2768_KLASSEN = new Set(['f', 'm', 'c', 'v']);
const PASSUNG_RE = /^([A-Za-z]{1,2})\s*(\d{1,2})\s*\/\s*([A-Za-z]{1,2})\s*(\d{1,2})$/;
// Reine Zahlen, optional mit „mm“: bleiben Sache von smartParseTol.
const ZAHL_MIT_MM_RE = /^[\s\d.,+\-\u2212/±]*(mm)?\s*$/i;

/**
 * Liefert
 *   { norm, formLage? }   bekannte Klasse (formLage: H/K/L aus „2768-mK“)
 *   { passung }           „H7/g6“: Bohrung und Welle gehören in zwei Zeilen
 *   { unbekannt }         sieht aus wie eine Klasse, gibt es aber nicht
 *   { unverstanden }      Text mit Buchstaben, der weder Zahl noch Klasse ist
 *   null                  Zahl (auch mit „mm“) oder leer
 */
export function parseNormKurzform(raw) {
  if (raw === null || raw === undefined) return null;
  const text = String(raw).trim();
  if (!text || !/\p{L}/u.test(text)) return null;

  const m286 = text.match(ISO286_RE);
  if (m286) {
    const bohrung = m286[1][0] === m286[1][0].toUpperCase();
    const buchstaben = bohrung ? m286[1].toUpperCase() : m286[1].toLowerCase();
    const klasse = `${buchstaben}${m286[2]}`;
    if (bohrung && BOHRUNGEN.has(klasse)) return { norm: `bores_${klasse}` };
    if (!bohrung && WELLEN.has(klasse)) return { norm: `shafts_${klasse}` };
    return { unbekannt: text };
  }

  const mPassung = text.match(PASSUNG_RE);
  if (mPassung) {
    return {
      passung: {
        bohrung: `${mPassung[1].toUpperCase()}${mPassung[2]}`,
        welle: `${mPassung[3].toLowerCase()}${mPassung[4]}`
      }
    };
  }

  const m2768 = text.match(ISO2768_RE);
  if (m2768) {
    const klasse = m2768[1].toLowerCase();
    if (!ISO2768_KLASSEN.has(klasse)) return { unbekannt: text };
    return m2768[2]
      ? { norm: `iso2768${klasse}`, formLage: m2768[2].toUpperCase() }
      : { norm: `iso2768${klasse}` };
  }

  if (ZAHL_MIT_MM_RE.test(text)) return null;
  return { unverstanden: text };
}
